/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_OperatingStatementAccountAttributes_ } from '../models/ControllerResponse_OperatingStatementAccountAttributes_';
import type { ControllerResponse_OperatingStatementAccountAttributes_Array_ } from '../models/ControllerResponse_OperatingStatementAccountAttributes_Array_';
import type { ControllerResponse_OperatingStatementBaseAccountAttributes_Array_ } from '../models/ControllerResponse_OperatingStatementBaseAccountAttributes_Array_';
import type { ControllerResponse_string_Array_ } from '../models/ControllerResponse_string_Array_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OperatingStatementAccountService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_OperatingStatementBaseAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public listBaseAccounts(): CancelablePromise<ControllerResponse_OperatingStatementBaseAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement_account/base',
        });
    }
    /**
     * @returns ControllerResponse_string_Array_ Ok
     * @throws ApiError
     */
    public listSets(): CancelablePromise<ControllerResponse_string_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement_account/sets',
        });
    }
    /**
     * @param accountSet
     * @returns ControllerResponse_OperatingStatementAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public index(
        accountSet: string,
    ): CancelablePromise<ControllerResponse_OperatingStatementAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement_account',
            query: {
                'accountSet': accountSet,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_OperatingStatementAccountAttributes_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: {
            display_name: string | null;
            maps_to_base_account_id: number | null;
            base_account_id: number;
            account_set: string;
        },
    ): CancelablePromise<ControllerResponse_OperatingStatementAccountAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/operating_statement_account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountSet
     * @returns ControllerResponse_OperatingStatementBaseAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public getDirectMembers(
        accountSet: string,
    ): CancelablePromise<ControllerResponse_OperatingStatementBaseAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement_account/members',
            query: {
                'accountSet': accountSet,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_OperatingStatementAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public createSet(
        requestBody: {
            name: string;
        },
    ): CancelablePromise<ControllerResponse_OperatingStatementAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/operating_statement_account/set',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountId
     * @param requestBody
     * @returns ControllerResponse_OperatingStatementAccountAttributes_ Ok
     * @throws ApiError
     */
    public update(
        accountId: number,
        requestBody: {
            display_name?: string | null;
            maps_to_base_account_id?: number | null;
        },
    ): CancelablePromise<ControllerResponse_OperatingStatementAccountAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/operating_statement_account/{accountId}',
            path: {
                'accountId': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountId
     * @returns void
     * @throws ApiError
     */
    public delete(
        accountId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/operating_statement_account/{accountId}',
            path: {
                'accountId': accountId,
            },
        });
    }
}
